import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Search3 = (props) => (
  <Icon viewBox="0 0 13 13" {...props}>
    <g>
      <title>Fill 1 Copy</title>
      <path d="M2.969 8.295a3.772 3.772 0 0 1 0-5.316 3.714 3.714 0 0 1 2.647-1.1c1.001 0 1.941.391 2.649 1.1a3.773 3.773 0 0 1 0 5.316 3.717 3.717 0 0 1-2.649 1.1c-1 0-1.94-.391-2.647-1.1zM13 11.26l-2.675-2.555a5.65 5.65 0 0 0-.736-7.055A5.586 5.586 0 0 0 5.616 0C4.18 0 2.741.55 1.646 1.65a5.652 5.652 0 0 0 0 7.973 5.587 5.587 0 0 0 3.97 1.652c1.215 0 2.416-.417 3.425-1.203l2.668 2.55L13 11.26z"
        fill="currentColor" fillRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default Search3;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Search3.js